import React from "react";

export default function FlexRow(props) {
  const { children, addlClassName, ...other } = props;

  return (
    <div
      className={`flex${!!addlClassName ? " " + addlClassName : ""}`}
      {...other}
    >
      <div className="mr-8">&nbsp;</div>
      {children}
      <div className="ml-8">&nbsp;</div>
    </div>
  );
}
